<div class="d-flex justify-content-center mb-5" dir="ltr"></div>

<!-- <p-table styleClass="style-shadow" dir="rtl"  [columns]="cols" dataKey="id" [paginator]="true" [rows]="5"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25, 50]" [globalFilterFields]="filterKeys"
    [value]="data" [tableStyle]="{ 'min-width': '50rem' }" [styleClass]="selectedSize + ' p-datatable-striped'"
    selectionMode="multiple" [exportHeader]="'customExportHeader'">

    <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between mobile-flex" dir="ltr">
            <div class="d-flex mobile-flex-end">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-secondary mr-2 mx-1 my-1" pTooltip="XLS" tooltipPosition="bottom"></button>

            </div>
            <p-selectButton class="mx-1 my-1 d-flex mobile-flex-end" [options]="sizes" [(ngModel)]="selectedSize"
                (onChange)="selectedSizeChange($event)" [multiple]="false" optionLabel="name"
                optionValue="class"></p-selectButton>
        </div>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>

            <th class="col" *ngFor="let key of filterKeys" >
                <span [innerHTML]="key.split('.')[0] !='Action' ? key.split('.')[0] : 'خيارات أخرى'"></span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr>
            <td *ngFor="let key of keys">
                <img *ngIf="checkisImg(item[key]?.i); else elseBlock" src="{{staticURL}}{{item[key]?.i}}"
                    class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                <span *ngIf="checkisImg(item[key]?.i);" style="white-space: pre">{{item[key]?.n}}</span>

                <ng-template #elseBlock>
                    <span *ngIf="key != 'Action'; else actionBlock">
                        <i class="{{item[key]?.i}} p-2" *ngIf="key != '#'" style="font-size: 1rem;"></i>
                        <span *ngIf="key != '#'" style="white-space: pre">{{item[key]?.n}}</span>
                        <span class="ms-tabel-num-box" *ngIf="key == '#'" style="white-space: pre">{{ i + 1 }}</span>
                    </span>
                    <ng-template #actionBlock>
                        <div class="d-flex">
                            <span *ngFor="let action of item[key]">
                                <button
                                    [hidden]="action.n == 'Delete' ? !checkDeletePermission() : !checkUpdatePermission()"
                                    class="tabel-circle-btn mx-1" (click)="actionClick(action.n , item['#'].n)"><i
                                        [ngClass]="action.i"></i></button>
                            </span>
                        </div>
                    </ng-template>
                </ng-template>
            </td>

        </tr>
    </ng-template>
</p-table> -->

<div class="grey-box">
  <div class="d-flex justify-content-between mobile-flex my-4" dir="ltr">
    <div class="d-flex mobile-flex-end">
      <div class="d-flex">
        <!-- <button
          type="button"
          pButton
          pRipple
          icon="pi pi-file-excel"
          (click)="exportExcel()"
          class="p-button-secondary mr-2 mx-1 my-1"
          pTooltip="XLS"
          tooltipPosition="bottom"
        ></button> -->
        <button
          class="xls-btn mr-0-8"
          (click)="exportExcel()"
          pTooltip="XLS"
          tooltipPosition="bottom"
          type="button"
        >
          <i class="pi pi-file-excel"></i>
        </button>
      </div>
    </div>
    <input
      dir="rtl"
      class="ms-input-view"
      type="text"
      [(ngModel)]="globalFilter"
      placeholder="بحث"
      (input)="applyGlobalFilter()"
    />

    <!-- <p-selectButton class="mx-1 my-1 d-flex mobile-flex-end" [options]="sizes" [(ngModel)]="selectedSize"
            (onChange)="selectedSizeChange($event)" [multiple]="false" optionLabel="name"
            optionValue="class"></p-selectButton> -->
  </div>
  <div class="table-main-scroll">
    <table #dt [style.width]="'100%'">
      <thead>
        <tr>
          <th
            scope="col"
            *ngFor="let key of filterKeys; let first = first"
            [style.width]="first ? '50px' : 'auto'"
          >
            <span
              [innerHTML]="
                key.split('.')[0] != 'Action'
                  ? key.split('.')[0]
                  : 'خيارات أخرى'
              "
            ></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-b-v4" *ngFor="let item of visibleData; let i = index">
          <td
            data-label="factor"
            *ngFor="let key of keys; let first = first"
            class="ms-tabel-td-mob-mr"
          >
            <div class="tabel-detail-box">
              <span
                class="{{
                  item[key]?.n?.length > 40
                    ? 'tab-scroll-more-data'
                    : 'tab-scroll'
                }}"
              >
                <img
                  *ngIf="checkisImg(item[key]?.i); else elseBlock"
                  src="{{ staticURL }}{{ item[key]?.i }}"
                  class="img-fluid p-1"
                  style="max-height: 30px; max-width: 30px"
                />
                <span
                  *ngIf="checkisImg(item[key]?.i)"
                  style="white-space: pre"
                  >{{ item[key]?.n }}</span
                >

                <ng-template #elseBlock>
                  <span *ngIf="key != 'Action'; else actionBlock">
                    <div *ngIf="key != '#'" class="d-flex flex-row">
                      <i
                        class="{{ item[key]?.i }} p-2"
                        style="font-size: 1rem"
                      ></i>
                      <span style="word-break: keep-all">{{
                        item[key]?.n
                      }}</span>
                    </div>

                    <span
                      class="ms-tabel-num-box"
                      *ngIf="key == '#'"
                      style="white-space: pre"
                      >{{ i + 1 + (currentPage - 1) * 10 }}</span
                    >
                  </span>
                  <ng-template #actionBlock>
                    <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                      <div class="tabel-detail-box">
                        <div
                          class="d-flex justify-content-between w-100 align-items-center"
                        >
                          <div class="d-flex">
                            <span *ngFor="let action of item[key]">
                              <div [pTooltip]="action.n | translator"
                                class="tabel-circle-btn"
                                *ngIf="handleUpdateDeletePermission(action.n)"
                                class="tabel-circle-btn mx-1"
                                (click)="actionClick(action.n, item['#'].n)"
                              >
                                <i [ngClass]="action.i"></i>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </span>
                  </ng-template>
                </ng-template>
              </span>
            </div>
            <!-- <img *ngIf="checkisImg(item[key]?.i); else elseBlock" src="{{staticURL}}{{item[key]?.i}}" class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                            <span *ngIf="checkisImg(item[key]?.i);" style="white-space: pre">{{item[key]?.n}}</span>
            
                            <ng-template #elseBlock>
                                <span *ngIf="key != 'Action'; else actionBlock">
                                    <i class="{{item[key]?.i}} p-2" *ngIf="key != '#'" style="font-size: 1rem;"></i>
                                    <span *ngIf="key != '#'" style="white-space: pre">{{item[key]?.n}}</span>
                                    <span class="ms-tabel-num-box" *ngIf="key == '#'" style="white-space: pre">{{ i + 1 }}</span>
                                </span>
                                <ng-template #actionBlock>
                                   <div class="d-flex">
                                    <span  *ngFor="let action of item[key]">
                                    <button [hidden]="action.n == 'Delete' ? !checkDeletePermission() : !checkUpdatePermission()" class="tabel-circle-btn mx-1" (click)="actionClick(action.n , item['#'].n)"><i [ngClass]="action.i"></i></button>
                                    </span>
                                   </div>
                                </ng-template>
                            </ng-template> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="ms-pgnator flex justify-content-center">
  <p-paginator
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    (onPageChange)="onPageChange($event)"
  ></p-paginator>
</div>
